import { getEnvVar } from '@studio/environment/getEnvVar';
import { Socket } from '@studio/sockets/Socket';

/**
 * Function to manage the socket connections and binding them to the store.
 */
export default function () {
  this.connect = function () {
    // Create a new socket object
    this._socket = new Socket(getEnvVar('REACT_APP_SF_REALTIME_ENDPOINT'));
    return this._socket;
  };

  this.bindToStore = function (store) {
    this._store = store;
  };
}
